import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=cc59cd20&scoped=true"
var script = {}
import style0 from "./privacy.vue?vue&type=style&index=0&id=cc59cd20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc59cd20",
  null
  
)

export default component.exports